<script setup lang="ts">
import type { CartItem as CartItemType } from '~/types/models/cart.model'

interface Props {
  items?: CartItemType[]
}

const props = withDefaults(defineProps<Props>(), {
  items: undefined,
})

const cartStore = useCartStore()
const passedItems = toRef(props, 'items')
const processedItems = computed(() => passedItems.value || cartStore.state.items)
</script>

<template>
  <ul data-test="cart-items">
    <li
      v-for="item in processedItems"
      :key="item.itemId"
      data-test="cart-item"
    >
      <CartItem
        :item="item"
        v-bind="$attrs"
      />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
ul li:not(:first-child) {
  padding-top: 1.5rem;
}
</style>
